import { render } from "./AbsentChart.vue?vue&type=template&id=4a8c0a4b&scoped=true"
import script from "./AbsentChart.vue?vue&type=script&lang=js"
export * from "./AbsentChart.vue?vue&type=script&lang=js"

import "./widget.css?vue&type=style&index=0&id=4a8c0a4b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8c0a4b"]])

export default __exports__